import { useGetNavMenu } from 'features/layout/header/navbar/use-get-nav-menu'

export const useNavPromo = (brand: string) => {
  let promotion
  const { data: navMenuItemList } = useGetNavMenu()
  const lastPromo = navMenuItemList?.findLast((nav) => nav.tag === 'promotion')
  if (lastPromo) {
    const promoBrands = lastPromo.categoryNav?.promotion?.brandKeys
    if (promoBrands?.includes(brand)) {
      promotion = { name: lastPromo.name, key: lastPromo.key ?? '' }
    }
  }
  return promotion
}
